import React, { useCallback } from 'react';
import ClickOutside from '@/components/ClickOutside';
import usePreviewProperty from '../../hooks/usePreviewProperty';
import PropertyOption from './components/PropertyOption';

const PreviewProperty = React.memo(() => {
  const { previewProperty, setPreviewProperty } = usePreviewProperty();
  const onOutsideClick = useCallback(
    () => setPreviewProperty(),
    [setPreviewProperty],
  );

  if (!previewProperty) {
    return null;
  }

  return (
    <ClickOutside onOutsideClick={onOutsideClick}>
      <PropertyOption propertyContent={previewProperty} />
    </ClickOutside>
  );
});

export default PreviewProperty;
